import { ApiResult, request, safeRequest } from '@synergy/api';
import { Employee } from '@synergy/models';

export class CustomerTopicsApi {
    constructor(protected baseUrl: string) {}

    public getEmployeeTopics(customerId: number): Promise<ApiResult<Employee[]>> {
        return safeRequest(
            () =>
                request.get<Employee[]>(`${this.baseUrl}/customers/${customerId}/employee-topics`, {
                    params: new URLSearchParams({ limit: '10000' }),
                }),
            response => response.data
        );
    }

    public updateEmployeeTopics(customerId: number, employeeId: number, topicIds: number[]): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.patch(`${this.baseUrl}/customers/${customerId}/employee-topics/${employeeId}`, { topicIds }),
            () => null
        );
    }
}
